module.exports = __webpack_public_path__ + "img/31.67a889bd.jpg";